import React, { useState } from "react";
import QuickStatusModal from "../HotelPage/StatusChange/QuickStatusModal";

const TAG_OPTIONS = [
  { value: "Lab", label: "Lab", description: "Hôtel en phase de test", color: "bg-blue-100 text-blue-800" },
  { value: "Live", label: "Live", description: "Hôtel en production", color: "bg-green-100 text-green-800" },
  { value: "Fini", label: "Fini", description: "Projet terminé", color: "bg-gray-100 text-gray-800" },
  { value: "Waiting", label: "Waiting", description: "En attente", color: "bg-yellow-100 text-yellow-800" },
  { value: "Démo", label: "Démo", description: "Hôtel de démonstration", color: "bg-purple-100 text-purple-800" },
  { value: "Autres", label: "Autres", description: "Autre catégorie", color: "bg-orange-100 text-orange-800" },
];

const getTagColor = (tag) => {
  if (!tag) return "bg-gray-100 text-gray-600";
  const option = TAG_OPTIONS.find((opt) => opt.value === tag);
  return option ? option.color : "bg-gray-100 text-gray-600";
};

const getTagLabel = (tag) => {
  if (!tag) return "Aucun";
  const option = TAG_OPTIONS.find((opt) => opt.value === tag);
  return option ? option.label : tag;
};

const ClickableTag = ({ tag, hotelId, onTagChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

  const handleTagClick = (e) => {
    e.stopPropagation();

    const rect = e.currentTarget.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    setModalPosition({
      top: rect.bottom + scrollTop,
      left: rect.left + scrollLeft,
    });

    setIsModalOpen(true);
  };

  const handleTagChangeInternal = async (newTag) => {
    try {
      await onTagChange(hotelId, newTag);
      setIsModalOpen(false);
    } catch (error) {
      console.error("Erreur lors du changement de tag:", error);
    }
  };

  // Créer un objet "room" factice pour réutiliser QuickStatusModal
  const fakeRoom = {
    id: hotelId,
    status: tag,
    room_nb: "Tag",
  };

  // Ajouter l'option "Aucun" (null) au début de la liste
  const availableTags = [
    { value: null, label: "Aucun", description: "Aucun tag assigné", color: "bg-gray-100 text-gray-600" },
    ...TAG_OPTIONS,
  ];

  return (
    <>
      <button
        onClick={handleTagClick}
        className={`
          inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium transition-all duration-150
          ${getTagColor(tag)}
          hover:shadow-sm hover:scale-105 cursor-pointer
        `}
        title="Cliquer pour changer le tag"
      >
        <span>{getTagLabel(tag)}</span>
        <svg className="ml-1 w-3 h-3 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Réutiliser QuickStatusModal avec les tags */}
      <QuickStatusModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        currentStatus={tag} 
        onStatusChange={handleTagChangeInternal} 
        room={fakeRoom}
        position={modalPosition}
        availableStatuses={availableTags}
      />
    </>
  );
};

export default ClickableTag;
